import React, { useCallback } from 'react'
import LeisureOption from '~/app/components-nds/domestic/cart/cart-product-section/items/leisure/option'
import { DomesticCartLeisureItem } from '~/api/converters/domestic/cart/ProductSection/Leisure/index.type'
import { ProductBadge, Divider } from '@yanolja-rnd/nol-design-system'
import conf from '~/app/conf'
import { isNative } from '~/app/utils/typeguards'
import { getYaNative } from '@yanolja-rnd/ya-native'
export interface LeisureItemProps {
  item: DomesticCartLeisureItem
}

const LeisureItem: React.FC<LeisureItemProps> = ({ item }) => {
  const { itemId, itemTitle, options } = item
  const onTitleClick = useCallback(() => {
    //TODO: (닥터) 레저 상품 타이틀 클릭 시 Kinesis 이벤트 전송 필요

    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.deepLink({ link: `yanoljamotel://leisure/detail?idx=${itemId}` })
    } else {
      location.href = `${conf.leisure.url}/leisure/${itemId}`
    }
  }, [itemId])

  return (
    <div className="rounded-16 bg-static-white p-16 pc:p-24">
      {/* 그룹 헤더 */}
      <div className="pb-16">
        {/* 국내레저 Badge */}
        <ProductBadge type="filled_secondary" size="medium" className="mb-6 px-6 py-2">
          국내레저
        </ProductBadge>

        {/* 타이틀 */}
        <div
          className="cursor-pointer text-text-neutral-main typography-subtitle-18-bold"
          onClick={onTitleClick}
        >
          {itemTitle}
        </div>
      </div>
      <Divider size="small" type="horizontal" className="mb-20" />

      {/* 아이템 목록 */}
      <div className="flex flex-col gap-40">
        {options.map((option, index) => (
          <LeisureOption key={index} option={option} onTitleClick={onTitleClick} />
        ))}
      </div>
    </div>
  )
}

export default LeisureItem
